import { PropsWithChildren } from 'react';

import { RootState } from '../../store/appStore';
import { DARK_THEME } from '../../utils/constants';
import { setProfileModal } from '../../store/slices/configSlice';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';

const ThemeProvider = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch();
  const { theme, showProfileModal } = useAppSelector(
    (store: RootState) => store.config
  );
  const handleModalHide = () => {
    if (showProfileModal) {
      dispatch(setProfileModal(!showProfileModal));
    }
  };
  return (
    <div
      data-testid='theme-provider'
      className={`${theme === DARK_THEME ? DARK_THEME : ''}`}
      onClick={handleModalHide}>
      <div className='flex flex-col h-screen justify-between bg-gray-100 dark:bg-slate-900'>
        {children}
      </div>
    </div>
  );
};

export default ThemeProvider;
